import Slideover from "./Slideover.vue";
import Description from "./Description.vue";
import Footer from "./Footer.vue";
import Panel from "./Panel.vue";
import Title from "./Title.vue";

const SlideoverComponent = Object.assign(Slideover, {
  Description,
  Footer,
  Panel,
  Title,
});

export default SlideoverComponent;
